import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import { TranslateHelper } from '@app/_helpers';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-options-details',
    templateUrl: './options-details.component.html',
    styleUrls: ['./options-details.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        DatePipe,
    ],
})
export class OptionsDetailsViewerComponent implements OnInit {
    constructor(public translate: TranslateService,
        public translateHelper: TranslateHelper) { }

    //service item data
    @Input() options;
    @Input() variant;

    _ = _
    ngOnInit(): void {
    }

}
